import React, { ReactNode } from 'react';
import * as Styled from './styled';
import Breadcrumbs, { Breadcrumb } from './Breadcrumbs/Breadcrumbs';
import { Heading, Grid } from '@mlc/web-ui-toolkit';

interface Props {
	asHero?: boolean;
	title: string;
	breadcrumbs?: Breadcrumb[];
}

class HeaderBanner extends React.Component<Props> {
	private pageTitleRef = React.createRef<Ref>();

	constructor(props: Props) {
		super(props);
	}

	componentDidMount() {
		if (this.pageTitleRef.current) {
			//@ts-ignore
			this.pageTitleRef.current.focus();
		}
	}

	render() {
		return (
			<Styled.Card
				display="flex"
				alignItems="center"
				data-analytics-group="breadcrumb"
			>
				<Grid>
					{this.props.breadcrumbs && (
						<Breadcrumbs
							breadcrumbs={this.props.breadcrumbs}
							pageTitle={this.props.title}
						/>
					)}
					<BannerTitle
						ref={this.pageTitleRef}
						asHero={this.props.asHero ? this.props.asHero : false}
					>
						{this.props.title}
					</BannerTitle>
				</Grid>
			</Styled.Card>
		);
	}
}

type BannerProps = {
	asHero: boolean;
	children: ReactNode;
};

type Ref = HTMLHeadElement;

const BannerTitle = React.forwardRef<Ref, BannerProps>((props, ref) =>
	props.asHero ? (
		<Heading
			el="h1"
			color="mlcWhite"
			forwardedRef={ref}
			tabIndex="-1"
			fontSize="regular"
			textAlign="center"
			fontWeight="medium"
		>
			{props.children}
		</Heading>
	) : (
		<Heading
			el="h1"
			marginBottom={6}
			color="mlcWhite"
			forwardedRef={ref}
			tabIndex="-1"
			fontSize="regular"
			fontWeight="medium"
			style={{ fontVariant: 'small-caps' }}
		>
			{props.children}
		</Heading>
	)
);

BannerTitle.displayName = 'Banner';

export default HeaderBanner;
